import React, { useState, useRef, useEffect } from "react";
import "./customCreatableMultiSelect.scss";
import { ClickAwayListener } from "@material-ui/core";
import deleteIcon from "../../../../assets/delete_icon_pre.svg";
import PainScale from "../../ERXMain/PHCView/PainScaleUI";
import {
  CUSTOM_BUTTON_STATUS,
  ERX_LIST_HEADER_KEY,
  SELECTION_LIST_TITLES,
} from "../../ERXConstants/constants";
import CustomChip from "../CustomChip";
import EditableLabel from "../EditableLabel";

const CustomCreatableMultiSelect = (props) => {
  const {
    inputLabel,
    placeholder,
    options,
    name,
    sectionName,
    menuIsOpen,
    value,
    hideInput,
    handleSearch,
    handleSelect,
    handleOnChange,
    handlePainScaleInput,
    handlePainScale,
    handleRemove,
    maxApiCall,
    setPageNo,
    pageNo,
    showDelete,
    deletePositionAtHeading,
    closeMenu,
    maxLength,
    handleCustomInput,
    hasCustomSaveButton,
    handleSaveCustomData,
    handleLabelInputChange,
  } = props;

  const [isTagEdited, setIsTagEdited] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [showPainScaleDropdown, setShowPainScaleDropdown] = useState(false);
  const [selectedName, setSelectedName] = useState("");
  const [painScaleData, setPainScaleData] = useState({});
  const [selectedPainScaleData, setSelectedPainScaleData] = useState("");
  const [editValueIndx, setEditValueIndx] = useState("");
  const [editValue, setEditValue] = useState("");
  const inputRef = useRef();
  const editRef = useRef();
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const MIN_TEXTAREA_HEIGHT = 32;

  // Lifecycle Methods ===>

  useEffect(() => {
    if (options.length !== 0) {
      let list = [];
      if (value.length > 0) {
        if (options?.length > 0) {
          options.forEach((opt) => {
            let index = value.findIndex(
              (d) =>
                (!isTagEdited ? true : d.id !== editValueIndx) &&
                d.title?.toLowerCase() === opt.title?.toLowerCase()
            );
            if (index === -1) {
              list.push(opt);
            }
          });
        }
      } else {
        list = [...options];
      }
      setFilteredOptions([...list]);
    } else {
      setFilteredOptions([...options]);
    }
  }, [options]);
  // to avoid showing the same option in the dropdown (if a value is already selected, it is not shown in the dropdown)

  useEffect(() => {
    if (!isTagEdited) {
      setShowOptions(true);
    }
  }, [isTagEdited]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.height = "15px";
      inputRef.current.style.height = `${Math.max(
        inputRef.current.scrollHeight,
        MIN_TEXTAREA_HEIGHT
      )}px`;
    }
  }, [inputValue, hideInput]);

  useEffect(() => {
    if (isTagEdited) {
      editRef.current.style.height = "15px";
      editRef.current.style.height = `${Math.max(
        editRef.current.scrollHeight,
        MIN_TEXTAREA_HEIGHT
      )}px`;
    }
  }, [editValue]);

  // <===

  // Helper Methods ===>

  const getValue = (item) => {
    let values = item?.value;
    if (
      item?.capture_painscale &&
      (item?.painScaleData?.pain_scale ||
        item?.painScaleData?.since ||
        item?.painScaleData?.area)
    ) {
      values = (
        <>
          {values}
          <span
            className={` ${
              selectedName && item?.value !== selectedName
                ? "disabled-multi-value"
                : "pain-scale-content"
            }`}
          >
            {` ${
              item?.painScaleData?.pain_scale
                ? " - " + item?.painScaleData?.pain_scale
                : " "
            }  ${
              item?.painScaleData?.since
                ? " - " + item?.painScaleData?.since
                : " "
            }  ${
              item?.painScaleData?.area
                ? " - " + item?.painScaleData?.area
                : " "
            }`}
          </span>
        </>
      );
    }

    return values;
  };

  // <===

  // <== Actions
  const handleDeleteChip = (index, title) => {
    let data = [...value.filter((tag) => value.indexOf(tag) !== index)];
    handleOnChange(title, data);
  };

  const toggleInput = (indx, tagValue) => {
    setEditValue(tagValue);
    setEditValueIndx(indx);
    setIsTagEdited(true);
    setTimeout(() => {
      let element = document.getElementById("edit_input");
      element.focus();
      element.setSelectionRange(element.value.length, element.value.length);
    }, 2);
  };

  const togglePainScale = (selectedValue) => {
    setInputValue("");
    handleSearch && handleSearch(name, "", 1, "search");
    selectPainScaleDefault(value, selectedValue);
  };

  const selectPainScaleDefault = (dataValue, selectedValue) => {
    let data = dataValue;
    let index = data.findIndex((ele) => ele?.value === selectedValue);
    setShowPainScaleDropdown(!showPainScaleDropdown);
    if (index !== -1) {
      setSelectedName(!data[index].showPainScale ? selectedValue : "");
      setPainScaleData(data[index].painScaleData);
      data[index].showPainScale = !data[index].showPainScale;
      handlePainScale(name, data);
    }
  };

  const handleKeyDown = (inputName, event) => {
    if (!inputValue) {
      switch (event.key) {
        case "Backspace":
          if (value?.length > 0) {
            let index = value?.length - 1;
            handleDeleteChip(index, inputName);
          }
          break;
        default:
      }
      return;
    }
    switch (event.key) {
      case "Enter":
      case "Tab":
        event.preventDefault();
        handleFreeText(inputName, event.target.value);
        setInputValue("");
        break;
      default:
    }
  };

  const handleEditKeyDown = (editName, event) => {
    switch (event.key) {
      case "Enter":
      case "Tab":
        if (editValue?.trim()?.length > 0) {
          handleEditedInput(editName, event);
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }
        break;
      default:
    }
  };

  const handlePainScaleInputField = (selectedValue, input) => {
    let data = value;
    let index = data.findIndex((e) => e?.value === selectedValue);
    if (index > -1) {
      data[index].painScaleData["since"] = input;
      handlePainScaleInput(name, value);
    }
  };

  const handlePainScaleSelectField = (selectedValue, input) => {
    let data = value;
    let index = data.findIndex((e) => e?.value === selectedValue);
    if (index > -1) {
      data[index].painScaleData["pain_scale"] = input?.value;
      data[index].painScaleData["selected_option"] = input;
      handlePainScale(name, value);
    }
  };

  const handleFreeText = (inputName, inpVal) => {
    setPageNo && setPageNo(1);
    let slug = "";
    if (inpVal?.trim()?.length > 0) {
      if (options.length > 0 && inputName === "instructions_and_notes") {
        let getSlugFilter = options.filter(
          (data) => data?.value?.toLowerCase() === inpVal?.toLowerCase()
        );
        if (getSlugFilter?.length > 0) {
          slug = getSlugFilter[0]?.slug;
        } else {
          slug = "";
        }
      }
      let knowledge_base_id,
        master_id = "";
      if (options?.length > 0 && inpVal?.trim()) {
        let filteredOption = options.filter(
          (item) =>
            // !item.master_id &&
            item.title.toLowerCase()?.trim() === inpVal.toLowerCase()?.trim()
        );
        if (filteredOption?.length > 0) {
          if (filteredOption[0]?.master_id) {
            master_id = filteredOption[0]?.master_id;
          } else {
            knowledge_base_id = filteredOption[0]?.knowledge_base_id ?? "";
          }
        }
      }
      let id = null;
      if (value?.length > 0) {
        let filteredData = value.filter(
          (d) =>
            d?.value?.trim()?.toLowerCase() === inpVal?.trim()?.toLowerCase()
        );
        if (filteredData?.length === 0) {
          id = value[value.length - 1].id + 1;
        }
      } else {
        id = 1;
      }

      if (id) {
        let obj = {
          id: id,
          value: inpVal?.trim(),
          ...(slug && { slug: slug }),
          ...(knowledge_base_id && { knowledge_base_id: knowledge_base_id }),
          ...(master_id && { master_id: master_id }),
        };
        handleCustomInput && handleCustomInput(inputName, obj);
      }
    }
  };

  const handleRadioBtn = (selectedValue, input) => {
    let data = value;
    let index = data.findIndex((e) => e?.value === selectedValue);
    if (index > -1) {
      data[index].painScaleData["area"] = input;
      handlePainScale(name, value);
    }
  };

  const handleEditSelect = (editSelectName, data) => {
    let newList = [...value];
    let index = newList.findIndex((item) => item.id === editValueIndx);
    let isValueDuplicate = newList.filter(
      (ele) =>
        ele.id !== editValueIndx &&
        ele.value?.trim()?.toLowerCase() === data?.value?.toLowerCase()
    );
    if (index > -1) {
      if (isValueDuplicate.length === 0) {
        if (
          (editSelectName !== ERX_LIST_HEADER_KEY.SUGGESTED_INVESTIGATION &&
            editSelectName !== SELECTION_LIST_TITLES.CUSTOM_SECTION1) ||
          (sectionName &&
            (sectionName !== ERX_LIST_HEADER_KEY.DIAGNOSIS ||
              sectionName !== ERX_LIST_HEADER_KEY.REPORT))
        ) {
          if (data?.master_id || data?.knowledge_base_id) {
            data["button_status"] = "";
          } else {
            data["button_status"] = CUSTOM_BUTTON_STATUS.SAVE;
          }
        }
        newList[index] = { ...newList[index], ...data };
        handleOnChange(editSelectName, newList);
      } else {
        handleRemoveDuplicate();
      }
    }

    setIsTagEdited(false);
    setEditValue("");
    if (data?.capture_painscale) {
      selectPainScaleDefault(newList, data?.value);
      setSelectedPainScaleData(data?.value);
    }
  };

  const handleSaveEditedInput = (editInputName, event) => {
    if (editValue?.trim()?.length > 0) {
      handleEditedInput(editInputName, event);
      setEditValueIndx("");
    } else {
      handleRemoveDuplicate();
    }
  };

  const handleEditedInput = (editedName, event) => {
    let newList = [...value];
    if (value?.length > 0) {
      let filteredData = value.filter(
        (d) =>
          d?.id !== editValueIndx &&
          d?.value?.toLowerCase()?.trim() === editValue?.toLowerCase()?.trim()
      );
      if (filteredData?.length > 0) {
        handleRemoveDuplicate();
        return;
      }
    }
    event.preventDefault();
    let slug = "";
    if (options.length > 0 && editedName === "instructions_and_notes") {
      let getSlugFilter = options.filter(
        (data) =>
          data?.value?.toLowerCase()?.trim() ===
          editValue?.toLowerCase()?.trim()
      );
      if (getSlugFilter?.length > 0) {
        slug = getSlugFilter[0]?.slug;
      } else {
        slug = "";
      }
    }
    let knowledge_base_id = "",
      master_id = "";
    if (options?.length > 0 && editValue?.trim()) {
      let filteredOption = options.filter(
        (item) =>
          // !item.master_id &&
          item.title?.toLowerCase()?.trim() ===
          editValue?.trim()?.toLowerCase()?.trim()
      );
      if (filteredOption?.length > 0) {
        if (filteredOption[0]?.master_id) {
          master_id = filteredOption[0]?.master_id;
        } else {
          knowledge_base_id = filteredOption[0]?.knowledge_base_id ?? "";
        }
      }
    }
    let newIndex = newList.findIndex((val) => val.id === editValueIndx);
    if (
      newList[newIndex]?.value?.toLowerCase()?.trim() !==
      editValue?.toLowerCase()?.trim()
    ) {
      let obj = {
        id: editValueIndx,
        title: editValue?.trim(),
        value: editValue?.trim(),
      };
      if (
        (editedName !== ERX_LIST_HEADER_KEY.SUGGESTED_INVESTIGATION &&
          editedName !== SELECTION_LIST_TITLES.CUSTOM_SECTION1) ||
        (sectionName &&
          (sectionName !== ERX_LIST_HEADER_KEY.DIAGNOSIS ||
            sectionName !== ERX_LIST_HEADER_KEY.REPORT))
      ) {
        obj = {
          ...obj,
          ...(slug && { slug: slug }),
          ...(knowledge_base_id && { knowledge_base_id: knowledge_base_id }),
          ...(master_id && { master_id: master_id }),
          button_status:
            knowledge_base_id || master_id ? "" : CUSTOM_BUTTON_STATUS.SAVE,
        };
      }
      newList[newIndex] = obj;
    } else {
      newList[newIndex]["title"] = editValue?.trim();
      newList[newIndex]["value"] = editValue?.trim();
      if (slug) {
        newList[newIndex]["slug"] = editValue;
      }
      if (
        (editedName !== ERX_LIST_HEADER_KEY.SUGGESTED_INVESTIGATION &&
          editedName !== SELECTION_LIST_TITLES.CUSTOM_SECTION1) ||
        (sectionName &&
          (sectionName !== ERX_LIST_HEADER_KEY.DIAGNOSIS ||
            sectionName !== ERX_LIST_HEADER_KEY.REPORT))
      ) {
        knowledge_base_id =
          newList[newIndex]["knowledge_base_id"] ?? knowledge_base_id;
        master_id = newList[newIndex]["master_id"] ?? master_id;
        if (knowledge_base_id || master_id) {
          newList[newIndex]["button_status"] = "";
        } else {
          newList[newIndex]["button_status"] = CUSTOM_BUTTON_STATUS.SAVE;
        }
      }
    }
    setIsTagEdited(false);
    setEditValue("");
    handleOnChange(editedName, newList);
  };

  const handleRemoveDuplicate = () => {
    let newList = [...value];
    if (newList?.length > 0) {
      newList = newList.filter((data) => data?.id !== editValueIndx);
      handleOnChange(name, newList);
      setIsTagEdited(false);
      setEditValue("");
      setEditValueIndx("");
    }
  };

  const handleEditChip = (tag) => {
    setShowOptions(false);
    setFilteredOptions([]);
    if (isTagEdited) {
      switch (editValue) {
        case editValue:
          let newList = [...value];
          let knowledge_base_id = "",
            master_id = "";
          if (options?.length > 0 && editValue) {
            let filteredOption = options.filter(
              (item) =>
                // !item.master_id &&
                item.title.toLowerCase()?.trim() ===
                editValue?.trim()?.toLowerCase()?.trim()
            );
            if (filteredOption?.length > 0) {
              if (filteredOption[0]?.master_id) {
                master_id = filteredOption[0]?.master_id;
              } else {
                knowledge_base_id = filteredOption[0]?.knowledge_base_id ?? "";
              }
            }
          }
          let newIndex = newList.findIndex(
            (index_value) => index_value.id === editValueIndx
          );
          if (
            newList[newIndex]?.value?.toLowerCase() !==
              editValue?.toLowerCase() &&
            editValue?.length > 0
          ) {
            let obj = {
              id: editValueIndx,
              title: editValue,
              value: editValue,
            };
            if (
              (name !== ERX_LIST_HEADER_KEY.SUGGESTED_INVESTIGATION &&
                name !== SELECTION_LIST_TITLES.CUSTOM_SECTION1) ||
              (sectionName &&
                (sectionName !== ERX_LIST_HEADER_KEY.DIAGNOSIS ||
                  sectionName !== ERX_LIST_HEADER_KEY.REPORT))
            ) {
              obj = {
                ...obj,
                ...(knowledge_base_id && {
                  knowledge_base_id: knowledge_base_id,
                }),
                ...(master_id && { master_id: master_id }),
                button_status:
                  knowledge_base_id || master_id
                    ? ""
                    : CUSTOM_BUTTON_STATUS.SAVE,
              };
            }
            newList[newIndex] = obj;
          } else {
            newList[newIndex]["title"] = editValue?.trim();
            newList[newIndex]["value"] = editValue?.trim();
            if (
              (name !== ERX_LIST_HEADER_KEY.SUGGESTED_INVESTIGATION &&
                name !== SELECTION_LIST_TITLES.CUSTOM_SECTION1) ||
              (sectionName &&
                (sectionName !== ERX_LIST_HEADER_KEY.DIAGNOSIS ||
                  sectionName !== ERX_LIST_HEADER_KEY.REPORT))
            ) {
              knowledge_base_id =
                newList[newIndex]["knowledge_base_id"] ?? knowledge_base_id;
              master_id = newList[newIndex]["master_id"] ?? master_id;
              if (knowledge_base_id || master_id) {
                newList[newIndex]["button_status"] = "";
              } else {
                newList[newIndex]["button_status"] = CUSTOM_BUTTON_STATUS.SAVE;
              }
            }
          }
          let filterData = newList.filter((data) => data.value !== "");
          handleOnChange(name, filterData);
          break;
        default:
          let allValue = value.filter((data) => data.id !== editValueIndx);
          handleOnChange(name, allValue);
          break;
      }
    }
    toggleInput(tag?.id, tag.value);
  };

  const handleEditedInputChange = (event) => {
    let newValue = event.target.value;
    if (maxLength) {
      newValue =
        newValue.length <= maxLength ? newValue : newValue.substr(0, maxLength);
    }
    if (showPainScaleDropdown) {
      togglePainScale(selectedPainScaleData);
    }
    setEditValue(newValue);
    setShowOptions(true);
    handleSearch && handleSearch(name, newValue?.trim(), 1, "search");
  };

  const handleInputChange = (event) => {
    let newValue = event.target.value;
    if (maxLength) {
      newValue =
        newValue.length <= maxLength ? newValue : newValue.substr(0, maxLength);
    }
    if (showPainScaleDropdown) {
      togglePainScale(selectedPainScaleData);
    }
    setInputValue(newValue);
    handleSearch && handleSearch(name, newValue?.trim(), 1, "search");
  };

  const handleClickAway = (e) => {
    if (inputValue) {
      handleFreeText(name, inputValue);
    }
    setInputValue("");
    if (isTagEdited) {
      handleSaveEditedInput(name, e);
    }
  };

  const handleClickWithinInput = (e) => {
    if (inputValue) {
      handleFreeText(name, inputValue);
    }
    setInputValue("");
    if (!isTagEdited) {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  };

  const handleClickAwayOptions = () => {
    if (inputValue) {
      handleFreeText(name, inputValue);
    }
    setInputValue("");
    closeMenu && closeMenu(name);
  };

  const handleOnScrollDropdown = (e) => {
    let bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    if (
      e.target.scrollHeight - Math.round(e.target.scrollTop) + 1 ===
      e.target.clientHeight
    ) {
      bottom = true;
    }
    if (
      e.target.scrollHeight - Math.round(e.target.scrollTop) - 1 ===
      e.target.clientHeight
    ) {
      bottom = true;
    }
    if (bottom) {
      if (pageNo < maxApiCall) {
        setPageNo(pageNo + 1);
        let searchValue = isTagEdited ? editValue?.trim() : inputValue?.trim();
        handleSearch(name, searchValue, pageNo + 1, "pagination");
      }
    }
  };

  const handleSelectedOption = (data) => {
    setPageNo(1);
    if (isTagEdited) {
      handleEditSelect(name, data);
    } else {
      handleSelect(name, data);
      setInputValue("");
      if (data?.capture_painscale) {
        selectPainScaleDefault([...value, data], data?.value);
        setSelectedPainScaleData(data?.value);
      }
    }
  };

  const handleEditClickAway = (e) => {
    if (window.innerWidth > 767) {
      handleSaveEditedInput(name, e);
    } else {
      if ((!showPainScaleDropdown && !menuIsOpen) || editValue?.length === 0) {
        handleSaveEditedInput(name, e);
      }
    }
  };

  // ==>

  // Display UI ===>

  const displayCustomMultiSelect = () => {
    return (
      <>
        {displayTitle()}
        <div style={{ position: "relative" }}>
          {displayMultiSelectContent()}
          {displayPainScaleDropdown()}
          {displayOptionsDropdown()}
        </div>
      </>
    );
  };

  const displayTitle = () => {
    return (
      <>
        {(inputLabel || handleLabelInputChange) && (
          <div className="custom-creatable-multi-select-title-container">
            <div className="custom-creatable-multi-select-title">
              {!handleLabelInputChange ? (
                inputLabel
              ) : (
                <EditableLabel
                  title={inputLabel}
                  handleEditInputChange={handleLabelInputChange}
                />
              )}
            </div>
            {deletePositionAtHeading && displayDeleteIcon()}
          </div>
        )}
      </>
    );
  };

  const displayMultiSelectContent = () => {
    return (
      <ClickAwayListener onClickAway={handleClickAway}>
        <div
          className="custom-creatable-multi-select-value-container"
          onClick={handleClickWithinInput}
        >
          <div className="custom-creatable-multi-select-value-wrap">
            {displayChipContent()}
            {!hideInput && displayInput()}
          </div>
          {!deletePositionAtHeading && displayDeleteIcon()}
        </div>
      </ClickAwayListener>
    );
  };

  const displayChipContent = () => {
    return (
      <>
        {value?.length > 0 &&
          value.map(
            (item, index) =>
              item?.value && (
                <div
                  key={item?.id}
                  className={
                    "custom-creatable-multi-select-value" +
                    (isTagEdited && item?.id === editValueIndx ? " w-100" : "")
                  }
                >
                  {isTagEdited && item?.id === editValueIndx ? (
                    <ClickAwayListener onClickAway={handleEditClickAway}>
                      <textarea
                        id={"edit_input"}
                        rows={1}
                        ref={editRef}
                        autoFocus={true}
                        value={editValue}
                        onChange={(event) => handleEditedInputChange(event)}
                        onKeyDown={(e) => handleEditKeyDown(name, e)}
                        style={{
                          minHeight: MIN_TEXTAREA_HEIGHT,
                          resize: "none",
                          overflow: "hidden",
                          width: "100%",
                          border: "none",
                        }}
                      />
                    </ClickAwayListener>
                  ) : (
                    <CustomChip
                      value={getValue(item)}
                      showSaveBtn={true}
                      showEditBtn={true}
                      hasCustomSaveButton={hasCustomSaveButton}
                      buttonStatus={item?.button_status ?? ""}
                      handleDeleteChip={() => {
                        handleDeleteChip(index, name);
                      }}
                      handleEditChip={() => handleEditChip(item)}
                      handleSaveChip={() =>
                        handleSaveCustomData(name, item?.id)
                      }
                    />
                  )}
                </div>
              )
          )}
      </>
    );
  };

  const displayInput = () => {
    return (
      <>
        <textarea
          type="text"
          placeholder={placeholder ?? ""}
          value={inputValue}
          onClick={(e) => {
            e.stopPropagation();
          }}
          onChange={(event) => handleInputChange(event)}
          onKeyDown={(e) => handleKeyDown(name, e)}
          ref={inputRef}
          style={{
            minHeight: MIN_TEXTAREA_HEIGHT,
            resize: "none",
            overflow: "hidden",
            width: "100%",
            background: "transparent",
            border: "none",
          }}
        />
      </>
    );
  };

  const displayDeleteIcon = () => {
    return (
      <>
        {showDelete && (
          <div>
            <img
              className="custom-creatable-multi-select-delete-icon"
              style={{ margin: "5px", cursor: "pointer" }}
              src={deleteIcon}
              alt="x"
              onClick={() => handleRemove(name)}
            />
          </div>
        )}
      </>
    );
  };

  const displayPainScaleDropdown = () => {
    return (
      <>
        {showPainScaleDropdown && (
          <ClickAwayListener
            onClickAway={() => {
              togglePainScale(selectedPainScaleData);
            }}
          >
            <div className="painscale-list-container">
              <PainScale
                name={name}
                selectedName={selectedName}
                painScaleData={painScaleData}
                handlePainScaleInput={handlePainScaleInputField}
                handlePainScaleSelect={handlePainScaleSelectField}
                handleRadioBtn={handleRadioBtn}
              />
            </div>
          </ClickAwayListener>
        )}
      </>
    );
  };

  const displayOptionsDropdown = () => {
    return (
      <>
        {(inputValue || editValue) &&
          menuIsOpen &&
          showOptions &&
          filteredOptions?.length > 0 && (
            <ClickAwayListener onClickAway={handleClickAwayOptions}>
              <div className="list-container" onScroll={handleOnScrollDropdown}>
                {filteredOptions.map((data, index) => (
                  <div
                    className="list"
                    key={index}
                    onClick={() => handleSelectedOption(data)}
                  >
                    {data?.label}
                  </div>
                ))}
              </div>
            </ClickAwayListener>
          )}
      </>
    );
  };

  // <===

  return (
    <div className="custom-creatable-multi-select">
      {displayCustomMultiSelect()}
    </div>
  );
};

export default CustomCreatableMultiSelect;
